/**
 * Journey Display Components for Travel Demo
 * 
 * Components for displaying journey progress and status.
 */

import React from 'react';
import { Card, CardContent } from '../../ui/card';
import { 
  Train,
  MapPin,
  Clock,
  ChevronRight
} from 'lucide-react';

// Journey progress display
export const JourneyProgress = ({ journey }) => {
  if (!journey) return null;
  
  return (
    <Card className="bg-slate-800/50 border-slate-700">
      <CardContent className="p-4">
        <div className="flex items-center gap-4">
          <div className="flex-1">
            <div className="flex items-center gap-2 text-white">
              <MapPin className="w-4 h-4 text-cyan-400" />
              <span className="font-medium">{journey.origin}</span>
              <ChevronRight className="w-4 h-4 text-slate-500" />
              <span className="font-medium">{journey.destination}</span>
            </div>
            <div className="flex items-center gap-4 mt-2 text-sm text-slate-400">
              <span className="flex items-center gap-1">
                <Train className="w-3 h-3" />
                {journey.service_name}
              </span>
              <span className="flex items-center gap-1">
                <Clock className="w-3 h-3" />
                {journey.departure_time} - {journey.arrival_time}
              </span>
            </div>
          </div>
          <div className="text-right">
            <div className="text-xs text-slate-500">Ticket Ref</div>
            <div className="font-mono text-cyan-400">{journey.ticket_reference}</div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
